import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import QRCodeStyling, { DotType, Options } from "qr-code-styling";
import axios from "axios";
import client, {
  API_HOST,
  UI_HOST,
  userSession,
} from "../../services/auth/ApiService/client";
import { initialState, IAllowFields, IAnketa, IRelationsResult, ITarriff, ITree } from "./model";
import {
  anketaToFormData,
  createFileFromImage,
  getCustomImageSize,
  getImageDimensions,
} from "./utils";

export const useChangePageForm = () => {
  const navigate = useNavigate();
  const [allowFields, setAllow] = React.useState<IAllowFields>({});
  const [anketa, setAnketa] = React.useState<IAnketa>(initialState);
  const [qrSrc, setQRSrc] = React.useState<string | undefined>(undefined);
  const [openSaveAlert, setOpenSaveAlert] = React.useState(false);
  const [selectedImages, setSelectedImages] = useState<string | undefined>(
    undefined
  );
  const refQR = useRef(null);

  const params = useParams();
  const { tariffid = "", id = "" } = params;

  const [gParams] = useSearchParams();
  const r = gParams.get("r");

  const initialRelation = {
    anketa: anketa,
    relation: "",
    position: 1,
  };
  const [relationsResult, setRelationsResult] = React.useState<
    IRelationsResult[]
  >([]);
  const options = {
    width: 200,
    height: 200,
    image:
      "https://storage.yandexcloud.net/northmemoryhotstore/logo-original-global.png",
    data: id
      ? `${UI_HOST}/${anketa.isSolder ? "solder" : "anketa"}/${id}`
      : `${UI_HOST}`,
    margin: 2,
    dotsOptions: {
      color: "#000000",
      type: "square",
    },
    imageOptions: {
      crossOrigin: "anonymous",
      margin: 5,
    },
  };

  const [newCoords, setNewCoords] = useState([69.050867, 33.256601]);
  const [address, setAddress] = useState("");

  const name = anketa?.name ?? "Этот момент памяти";

  const [qrCode] = useState<QRCodeStyling>(
    new QRCodeStyling(options as Options)
  );

  const getQRCodeData = async () => {
    const data = await qrCode.getRawData("png");
    console.log(data);
    return data as any;
  };

  const getQRCodeUrl = async () => {
    const data = await getQRCodeData();
    if (!data) return undefined;
    const src = URL.createObjectURL(data);
    setQRSrc(src);
  };

  useEffect(() => {
    const tId = tariffid;
    const loadData = () => {
      if (tId) {
        axios
          .get(`${API_HOST}/tariff/${tId}`)
          .then((response) => {
            const data = response.data as ITarriff;
            console.log(data?.allowFields);
            setAllow(data.allowFields);
            setRelationsResult([
              {
                anketa: {
                  ...initialState,
                  name: "Этот момент памяти",
                },
                relation: "",
                position: 1,
              },
            ]);
            setNewCoords([69.050867, 33.256601]);
          })
          .catch((error) => {
            console.log("error");
            console.log(error);
          });
      } else {
        axios.get(`${API_HOST}/anketas/${id}`).then((response) => {
          const data = response.data?.anketa as IAnketa;
          data.orderStatus =
            data?.orders?.length > 0 ? data.orders[0].status : "NEW";
          setAnketa(data);
          if (response?.data?.relations && response?.data?.trees) {
            const rRelations = response?.data?.trees.map((tree: ITree) => {
              const rAnketa = response?.data?.relations.find(
                (relation: any) => relation.id === tree.anketaToId
              );
              return {
                anketa: rAnketa,
                relation: tree.name,
                position: tree.position,
              };
            });
            setRelationsResult(rRelations);
            if (data?.coordinates?.coords) {
              const x = Number(data.coordinates.coords[0]);
              const y = Number(data.coordinates.coords[1]);
              setNewCoords([x, y]);
              setAddress(data.coordinates.address);
            }
          }
          axios.get(`${API_HOST}/tariff/${data?.tariffId}`).then((response) => {
            const data = response.data as ITarriff;
            setAllow(data.allowFields);
          });
          console.log("current", refQR?.current);
          if (refQR?.current) {
            qrCode.append(refQR?.current);
          }
          console.log(data);
        });
      }
    };
    loadData();
    if (refQR?.current) {
      qrCode.append(refQR.current);
      getQRCodeUrl();
    }
  }, []);

  useEffect(() => {
    if (tariffid) {
      const currentRelation =
        relationsResult.find((relation) => !relation?.anketa?.id) ??
        initialRelation;
      setRelationsResult([
        {
          ...currentRelation,
          anketa: currentRelation?.anketa ?? initialState,
        },
        ...relationsResult.filter((relation) => relation?.anketa?.id),
      ]);
    }
  }, [name]);

  useEffect(() => {
    console.log("check");
    qrCode.update({
      dotsOptions: {
        type: (anketa?.customQRCode?.type as DotType) ?? "square",
      },
    });
    if (refQR.current) {
      qrCode.append(refQR.current);
    }
  }, [anketa?.customQRCode?.type]);

  useEffect(() => {
    getQRCodeUrl();
  }, [anketa?.customQRCode?.type]);

  const handleSelectImage = async (src: string) => {
    setSelectedImages(src);
    const blob = await createFileFromImage(src, "file.png");
    if (blob) {
      const dimensions = await getImageDimensions(src);
      const { width, height } = getCustomImageSize(
        dimensions.width,
        dimensions.height
      );
      setAnketa({
        ...anketa,
        customImage: {
          ...anketa.customImage,
          buffer: blob,
          src,
          width,
          height,
        },
      });
      qrCode.update({
        width: 100,
        height: 100,
      });
    }
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();

    const bio = anketaToFormData({ bio: anketa.bio });
    const formData = anketaToFormData({ ...anketa, ...{ bio: [] } });
    if (relationsResult?.length > 1) {
      relationsResult.forEach((relation, key) => {
        formData.append(`relations[${key}][position]`, relation.position);
        formData.append(`relations[${key}][relation]`, relation.relation);
        formData.append(`relations[${key}][id]`, relation.anketa.id);
      });
    }
    if (r) {
      formData.append(`referalId`, r);
    }
    if (tariffid) {
      formData.append("tariffId", tariffid);
    }
    if (address && newCoords) {
      formData.append("map[address]", address);
      formData.append("map[coords][0]", newCoords[0]);
      formData.append("map[coords][1]", newCoords[1]);
    }
    if (tariffid) {
      if (userSession.getSession()) {
        client
          .post("/anketas/new", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response: any) => {
            console.log(response);
            client
              .post(`/anketas/bio/${response?.data?.anketa?.id}`, bio, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              })
              .then((response: any) => {
                setOpenSaveAlert(true);
                navigate("/profile");
              })
              .catch((error) => {
                console.log(error);
              });
            // navigate('/profile')
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        axios
          .post(`${API_HOST}/anketas/new/${r}`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response: any) => {
            console.log(response);
            if (bio.length > 0) {
              axios
                .post(
                  `${API_HOST}/anketas/bio/${response?.data?.anketa?.id}/${r}`,
                  bio,
                  {
                    headers: {
                      "Content-Type": "multipart/form-data",
                    },
                  }
                )
                .then((response) => {
                  setOpenSaveAlert(true);
                  // navigate('/profile')
                })
                .catch((error) => {
                  console.log(error);
                });
            }
            setOpenSaveAlert(true);
            // navigate('/profile')
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {
      client
        .post(`/anketas/${id}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          client
            .post(`/anketas/bio/${id}`, bio, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              setOpenSaveAlert(true);
              // navigate('/profile')
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const handleServicePriceChange = (index: number, newPrice: number) => {
    setAnketa((prev: IAnketa) => {
      const updatedServices =
        prev?.AnketaService &&
        prev?.AnketaService.map((service, i) =>
          i === index ? { ...service, price: newPrice } : service
        );
      return {
        ...prev,
        AnketaService: updatedServices,
      };
    });
  };

  return {
    address,
    allowFields,
    anketa,
    handleSelectImage,
    handleServicePriceChange,
    handleSubmit,
    id,
    initialRelation,
    newCoords,
    openSaveAlert,
    qrCode,
    qrSrc,
    r,
    refQR,
    relationsResult,
    selectedImages,
    setAddress,
    setAnketa,
    setNewCoords,
    setOpenSaveAlert,
    setRelationsResult,
    tariffid,
  };
};
